export enum Endpoint {
	Refresh = "refresh",
	RefreshWorkload = "workload/refresh",
	SignInAzureAD = "signIn",
	SignOut = "signOut",
	VerifyUser = "verify",
	Client = "client",
	TenantId = "tenant/id",
	Join = "join",
	UnJoin = "unjoin",
	Resources = "resources",
	List = "list",
	Profile = "profile",
	Accept = "accept",
	Reject = "reject",
	Favorites = "favorites",
	FavoritesAgents = "favorites/agents",
	Transfer = "coldTransferAgent",
	ColdTransferIvr = "coldTransferIvr",
	WarmTransferIvr = "warmTransferIvr/start",
	TransferByRouting = "transferByRouting",
	TransferIvrDestinations = "coldTransferIvr/destinations",
	StartTransfer = "warmTransfer/start",
	CancelTransfer = "warmTransfer/cancel",
	FinalizeTransfer = "warmTransfer/finalize",
	ConsultAgent = "warmTransfer/consultAgent",
	ConsultCaller = "warmTransfer/consultCaller",
	ConferenceMode = "warmTransfer/conferenceMode",
	Pause = "pause",
	Resume = "resume",
	Park = "park",
	UnPark = "unpark",
	WrapUp = "wrapup",
	WrapUpCode = "code",
	GraphToken = "graph/token",
	AcsToken = "acs/token",
	PickUp = "pickUp",
	Assign = "assign",
	TrustedEndpoints = "endpoints",
	Outbound = "outboundFromApp",
	Azure = "azure",
	Interactions = "interactions",
	Tone = "tone",
	Terminate = "terminate",
	SalesforceCases = "salesforce/cases",
	MessagingCrmContext = "crm-context",
	MessagingSalesforceCases = "crm-cases",
	Delete = "delete",
	Agents = "agents",
	AllActiveInteractions = "active",
	AllWaitingInteractions = "waiting",
	Attachments = "attachments",
	Messages = "messages",
	CreateReplyDraft = "reply/draft",
	CreateReplyAllDraft = "replyAll/draft",
	CreateForwardDraft = "forward/draft",
	ManageDraft = "draft",
	AttachmentUpload = "attachments/upload",
	AttachmentDelete = "attachments/delete",
	DeleteDraft = "draft/delete",
	IsSupervisor = "isSupervisor",
	Queues = "queues",
	OfferCallsToAgentsWithoutClient = "offerCallsToAgentsWithoutClient",
	EstimatedWaitTime = "estimatedWaitTime",
	MonitoringStart = "monitoring/start",
	MonitoringSwitch = "monitoring/switch",
	MonitoringStop = "monitoring/stop",
	MarkLastMessageAsSeen = "markLastMessageAsSeen",
	Close = "close",
	Desire = "desire",
	CurrentInvite = "currentInvite",
	Deleted = "deleted",
	Handled = "handled",
	MessagingTransfer = "transfer/initiate",
	MessagingTransferToQueue = "transferToQueue/initiate",
	MessagingTransferAccept = "transfer/accept",
	MessagingTransferReject = "transfer/reject",
	MessagingTransferDestinations = "getTransferDestinations",
	Stop = "stop",
	Email = "email",
	Phone = "phone",
	Name = "name",
	Id = "id",
	Update = "update",
	Contacts = "contacts",
	Notes = "notes",
	Workload = "workload",
	TotalWorkload = "workload/total",
	EmailMonitoring = "monitoring",
	AcceptSimultaneouslyOfferedCall = "simultaneousOffered/accept",
	RejectSimultaneouslyOfferedCall = "simultaneousOffered/reject",
	RingingFile = "ringingFile",
	ReopenEmailConversation = "reopen",
	Summary = "summary",
	CanGenerateSummary = "canGenerateSummary",
	VerifyHasClient = "verify-has-client",
	SetClientOn = "set-client-on",
	Filled = "filled",
	SingleSend = "singleSend",
	MyQueues = "myQueues",
	Voicemails = "voicemails",
	Media = "media",
	Send = "send",
	Body = "body",
	WhatsApp = "whatsapp",
	Reply = "reply",
	Webchat = "webchat",
	UploadUrl = "attachments/uploadUrl",
	Transcription = "transcription",
	TranscriptionStart = "transcription/start",
	TranscriptionUpdate = "transcription/update",
	TranscriptionStop = "transcription/stop",
	Recording = "recording",
	RecordingStart = "recording/start",
	RecordingStop = "recording/stop",
	MuteStart = "mute",
	MuteStop = "unmute",
	QueueStatistics = "queues/statistics",
	Preview = "preview",
	PreviewStarted = "preview/started",
	PreviewStopped = "preview/stopped",
	IsAnyCallInProgress = "workload/call-in-progress",
	EnableCallSummary = "enableCallSummary",
	EnableTextSummary = "enableTextSummary",
	TranscriptionLanguageSetting = "transcriptionLanguage",
	VideoCallRequest = "videoCall/request",
	VideoCallCancel = "videoCall/cancel",
	WebchatVideoOutbound = "webchatVideo/outbound",
	VoicemailTransfer = "transfer",
	VoicemailTransferToQueue = "transferToQueue",
	User = "user",
	FilterValues = "filter-values",
}
